import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import { ProfileContext } from "../../../Services/ProfileProvider";
import { useNavigate } from "react-router-dom";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";

const EditProfile = () => {

	const { userDetails, handleUserProfile } = useContext(ProfileContext);
	const navigate = useNavigate();

	const [formData, setFormData] = useState(
		{
			name: "",
			emailId: "",
			mobileNumber: "",
			image: "",
			imagePath: "",
			dob: ""
		}
	);

	const handleInput = (event) => {
		const { name, value, files } = event.target;
		if (name === 'image' && files && files.length > 0) {
			const file = files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setFormData(prevState => ({
					...prevState,
					image: reader.result,
					imagePath: file
				}));
			};
			reader.readAsDataURL(file);
		} else if (name === 'mobileNumber') {
			if (value.length <= 10) {
				setFormData(prevState => ({
					...prevState,
					[name]: value
				}));

			} else {
				alertErrorMessage("Mobile number cannot exceed 10 digits");
			}
		} else {
			setFormData(prevState => ({
				...prevState,
				[name]: value
			}));
		}
	};

	useEffect(() => {
		if (userDetails) {
			setFormData({
				name: userDetails.name || "",
				emailId: userDetails.emailId || "",
				mobileNumber: userDetails.phone_number || "",
				image: ApiConfig.url + userDetails?.user_image || "",
				imagePath: userDetails?.user_image || "",
				dob: userDetails?.dob || "",
			});
		}
	}, [userDetails]);


	const handleUpdateProfile = async () => {
		if (formData.mobileNumber.length !== 10) {
			alertErrorMessage("Mobile number cannot exceed 10 digits");
		}
		var formValue = new FormData();
		formValue.append("name", formData.name);
		formValue.append("emailId", formData.emailId);
		formValue.append("phone_number", formData.mobileNumber);
		formValue.append("dob", formData.dob);
		formValue.append("user_image", formData.imagePath);
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.updateProfile(formValue);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				handleUserProfile();
				navigate('/user_profile')
			} else {
				alertErrorMessage(result);
			}
		} catch (error) {
			LoaderHelper.loaderStatus(false);
			alertErrorMessage(error);
		}
	};

	return (
		<div class="wrapper dashboard_page ">
			<div class=" page-body d-flex align-items-stretch">
				<div class="page-content">
					<Sidebar />
					<div className="page_wrapper" >
						<div className="container container-custom" >
							<div className="row g-3" >

								<div className="col-lg-12" >
									<div className="card bal_card_main" >

										<div class="card-body ">
											<h4 class="">  Edit your personal information </h4>
											<p>
												Here you can view and change your personal information on our platform.
												Please note that the details should be correct and up-to-date.
											</p>
											<form className="mt-4 mt-xl-5" >
												<div class="col-md-12">
													<div class="img-prev">
														<div class="avatar-preview">
															<img src={formData.image || "/assets/images/NEWUSER.jpeg"} className="img-fluid" alt="Profile"
																onError={(e) => {
																	e.target.onerror = null;
																	e.target.src = "/assets/images/NEWUSER.jpeg";
																}}
															/>
														</div>
														<div class="avatar-edit">
															<input type="file" id="imageUpload" name="image" onChange={handleInput} />
															<label for="imageUpload"><i class="ri-upload-cloud-2-line me-2"></i>Upload Photo</label>
															<small>Click button to upload photo</small>
														</div>
													</div>
												</div>
												<div class="mb-3">
													<label class="form-label" for="exampleInputName">Name</label>
													<input class="form-control" id="exampleInputName" type="text" name="name" value={formData.name} onChange={handleInput} disabled />
												</div>
												<div class="mb-3">
													<label class="form-label" for="exampleInputEmail1">Email ID</label>
													<input class="form-control" id="exampleInputEmail1" type="email" name="emailId" value={formData.emailId} onChange={handleInput} disabled />
												</div>
												<div class="mb-3">
													<label class="form-label" for="exampleInputMobile">Mobile No</label>
													<input class="form-control" id="exampleInputMobile" type="tel" name="mobileNumber" value={formData.mobileNumber} onChange={handleInput} />
												</div>
												<div class="mb-3">
													<label class="form-label" for="exampleInputdob"> Date Of Birth </label>
													<input class="form-control" id="exampleInputdob" type="date" name="dob" value={formData.dob} onChange={handleInput} disabled />
												</div>
												<button class="btn btn-primary w-100 mt-3" type="button" onClick={handleUpdateProfile}>SUBMIT</button>
											</form>
										</div>

									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default EditProfile


